"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchBasketUpdatedEvent = exports.default = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const dispatchBasketUpdatedEvent = (detail, eventType = BasketUpdated.Name) => {
  const event = new CustomEvent(eventType, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchBasketUpdatedEvent = dispatchBasketUpdatedEvent;
var _default = exports.default = dispatchBasketUpdatedEvent;
